import PageNotFoundContainer from "./Containers/PageNotFoundContainer";
export default PageNotFoundContainer;
